import axios from 'api';
import { CreateEventRequest } from 'redux/event/event.types';

const url = '/api/events';

const encodeQueryValue = (value: string) =>
  encodeURIComponent(value)
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']');

const serializeParams = (params: Record<string, any>) => {
  const parts: string[] = [];

  Object.keys(params || {}).forEach((key) => {
    const val = params[key];
    if (val === null || typeof val === 'undefined') return;

    if (Array.isArray(val)) {
      val.forEach((item) => {
        let v = item;
        if (v instanceof Date) v = v.toISOString();
        else if (typeof v === 'object') v = JSON.stringify(v);
        parts.push(`${encodeQueryValue(`${key}[]`)}=${encodeQueryValue(String(v))}`);
      });
      return;
    }

    let v = val;
    if (v instanceof Date) v = v.toISOString();
    else if (typeof v === 'object') v = JSON.stringify(v);

    parts.push(`${encodeQueryValue(key)}=${encodeQueryValue(String(v))}`);
  });

  return parts.join('&');
};

const EventAPI = {
  getAll: (params: Record<string, any>) =>
    axios.get(url, {
      params,
      paramsSerializer: serializeParams,
    }),
  getOne: (id: string) => axios.get(`${url}/${id}`),
  create: (data: CreateEventRequest) => axios.post(url, data),
  update: (data: Partial<CreateEventRequest>) => axios.patch(`${url}/${data?.event?._id}`, data),
  delete: (id: string) => axios.delete(`${url}/${id}`),
  getAvailableStatuses: (id: string) => axios.get(`${url}/${id}/available-statuses`),
};

export default EventAPI;
